import React from "react";
import "./Location.css";
import airplane from "../../assets/imgs/airplane.png";
import train from "../../assets/imgs/train.png";
import market from "../../assets/imgs/market.png";
import highway from "../../assets/imgs/highway.png";
import park from "../../assets/imgs/park.png";
import school from "../../assets/imgs/school.png";
import hospital from "../../assets/imgs/hospital.png";

export default function Location() {
  return (
    <div className="locMn" id="location">
      <div className="maxW">
        <h2 className="locHd">Location</h2>
    

        <p className="locTxt">
          Sector 135 is one of the fastest-growing locations in Noida, well connected
          to major highways, residential hubs, and commercial developments. With
          corporate towers, schools, hospitals, and entertainment zones nearby, this 
          locality promises excellent convenience for modern living.
        </p>

        <div className="locFlex">
          <div className="locMap">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3512.279434600695!2d77.38809957552824!3d28.52588917572198!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cef3d442359b5%3A0xa50dbdea7e63e367!2sSector%20135%2C%20Noida%2C%20Uttar%20Pradesh%20201304!5e0!3m2!1sen!2sin!4v1702022229994!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Sector 135 Noida Map"
            ></iframe>
          </div>

         <div className="locGrid">
  <div className="locCell">
    <img src={airplane} alt="" />
    <div>
      <h4>Baroda Airport</h4>
      <p>20 KM drive</p>
    </div>
  </div>

  <div className="locCell">
    <img src={park} alt="" />
    <div>
      <h4>Atapi Water Park</h4>
      <p>2.3 KM near by</p>
    </div>
  </div>

  <div className="locCell">
    <img src={train} alt="" />
    <div>
      <h4>Baroda Railway Station</h4>
      <p>20 Km drive</p>
    </div>
  </div>

  <div className="locCell">
    <img src={school} alt="" />
    <div>
      <h4>Poddar International School</h4>
      <p>20 Km drive</p>
    </div>
  </div>

  <div className="locCell">
    <img src={market} alt="" />
    <div>
      <h4>APMC Market Ajwa Road</h4>
      <p>14 KM away</p>
    </div>
  </div>

  <div className="locCell">
    <img src={hospital} alt="" />
    <div>
      <h4>New Life Hospital</h4>
      <p>11 KM away</p>
    </div>
  </div>

  <div className="locCell fullRow">
    <img src={highway} alt="" />
    <div>
      <h4>NH-8 (Delhi–Mumbai Highway)</h4>
      <p>Just 12 KM away</p>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  );
}
